

















































































import { Component, Vue } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
import SingleCard from "@/components/cards/SingleCategoryCard.vue";
import axios from "axios";
import EditPodcast from "@/components/modals/EditPodcast.vue";
import NewCategory from "@/components/modals/NewPodcastCategory.vue";
import wordCategory from "@/model/module/word_category";
import Spiner from "@/components/englishjanala/Spiner.vue";

/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
import * as data from "@/model/englishjanala/englishjanala.json";
import { Dialog, Notify } from "vant";
@Component({
  components: {
    sidebar,
    ConversationIcon,
    WordsIcon,
    GrammarIcon,
    HeadphonSVG,
    SingleCard,
    NewCategory,
    EditPodcast,
    Spiner,
  },
})
export default class Words extends Vue {
  Spiner: boolean = true;
  podcasts: any = null;
  CategoryName: string = "Podcasts";
  currentRoute: any;
  nextRoute: any;
  currentIndex = -1;
  MouseHover(index: any) {
    this.currentIndex = index;
  }
  MouseLeave() {
    this.currentIndex = -1;
  }
  DeleteCategory(id: any, index: any) {
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        const PassData = { podcast_id: id };
        const response = axios
          .post(
            "https://api.englishjanala.com:8443/v1/englishjanala/podcast/PodcastService/DeletePodcast",
            PassData
          )
          .then()
          .catch((error) => {
            Notify({ type: "danger", message: "Podcast is not deleted" });
          });
        this.$delete(this.podcasts, index);
        Notify({ type: "success", message: "Podcast deleted" });
      })
      .catch(() => {
        // on cancel
      });
  }
  get currentRouteName() {
    return this.$route.name;
  }
  async mounted() {
    const offset = { offset: 12 };
    // get all category list
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/podcast/PodcastService/GetPodcastList",
      offset
    );
    const data = response.data.podcasts;
    this.podcasts = data;
    console.log(data);
    console.log(response.data);
    this.Spiner = false;
  }
  showModal(index: any) {
    const modal_id = "modal_" + index;
    this.$refs[modal_id][0].showPopup();
  }
}
